// Bianca Reyes Theme JS
document.addEventListener('DOMContentLoaded', function() {

  // Header scroll behavior
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;
      if (currentScroll > 50) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      lastScroll = currentScroll;
    });
  }

  // Mobile menu
  const menuToggle = document.querySelector('.menu-toggle');
  const mobileMenu = document.querySelector('.mobile-menu');
  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', () => {
      menuToggle.classList.toggle('active');
      mobileMenu.classList.toggle('open');
      document.body.style.overflow = mobileMenu.classList.contains('open') ? 'hidden' : '';
    });
    // Cerrar al tocar un link (anclas a la misma página no recargan) y con Esc.
    mobileMenu.addEventListener('click', (e) => {
      if (e.target.closest('a')) {
        menuToggle.classList.remove('active');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && mobileMenu.classList.contains('open')) {
        menuToggle.classList.remove('active');
        mobileMenu.classList.remove('open');
        document.body.style.overflow = '';
      }
    });
  }

  // Cart drawer
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-drawer-overlay');
  const cartTriggers = document.querySelectorAll('[data-cart-trigger]');
  const cartClose = document.querySelectorAll('[data-cart-close]');

  function openCart() {
    if (cartDrawer) cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  }

  function closeCart() {
    if (cartDrawer) cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartTriggers.forEach(t => t.addEventListener('click', (e) => {
    e.preventDefault();
    openCart();
  }));

  cartClose.forEach(c => c.addEventListener('click', closeCart));
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  // Refresh cart
  async function refreshCart() {
    try {
      const response = await fetch('/cart.js');
      const cart = await response.json();
      updateCartUI(cart);
    } catch (e) {
      console.error('Cart fetch error:', e);
    }
  }

  function updateCartUI(cart) {
    const cartBody = document.querySelector('.cart-drawer-body');
    const cartTotal = document.querySelector('.cart-total-price');

    // Update the cart pill TOTAL (price) — never overwrite this with a count
    document.querySelectorAll('.cart-pill__total').forEach(el => {
      const cents = cart.total_price || 0;
      el.textContent = (cents / 100).toLocaleString('en-US', {
        style: 'currency',
        currency: cart.currency || 'USD',
        minimumFractionDigits: 0
      });
    });

    // Update legacy .cart-count nodes (badges) with the item count,
    // BUT skip any that are also .cart-pill__total — those display money.
    document.querySelectorAll('.cart-count').forEach(el => {
      if (el.classList.contains('cart-pill__total')) return;
      el.textContent = cart.item_count;
    });

    if (cartBody) {
      if (cart.item_count === 0) {
        cartBody.innerHTML = '<div class="cart-empty"><p>Your cart is empty</p></div>';
      } else {
        cartBody.innerHTML = cart.items.map(item => `
          <div class="cart-item" data-key="${item.key}">
            <div class="cart-item-image">
              ${item.image ? `<img src="${item.image}" alt="${item.title}">` : ''}
            </div>
            <div>
              <div class="cart-item-title">${item.product_title}</div>
              <div class="cart-item-price">${formatMoney(item.final_price)} × ${item.quantity}</div>
              <button data-remove="${item.key}" style="font-size:12px;color:#666;margin-top:8px;text-decoration:underline;">Remove</button>
            </div>
            <div class="cart-item-total">${formatMoney(item.final_line_price)}</div>
          </div>
        `).join('');

        cartBody.querySelectorAll('[data-remove]').forEach(btn => {
          btn.addEventListener('click', async (e) => {
            const key = e.target.dataset.remove;
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: key, quantity: 0 })
            });
            refreshCart();
          });
        });
      }
    }

    if (cartTotal) {
      cartTotal.textContent = formatMoney(cart.total_price);
    }
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Initial cart load
  refreshCart();

  // Add to cart forms
  document.querySelectorAll('form[action="/cart/add"], form[action*="/cart/add"]').forEach(form => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const formData = new FormData(form);
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        });
        if (response.ok) {
          openCart();
        }
      } catch (err) {
        console.error('Add to cart error:', err);
      }
    });
  });

  // Lazy fade in
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('fade-in');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    document.querySelectorAll('.masonry-item, .project-gallery-item, .product-card').forEach(el => {
      observer.observe(el);
    });
  }
});
